import NavigationHeader from "../components/Layout/NavigationHeader";

const LearnMorePage = () => {
  return (
    <div className={"page_content"}>
      <NavigationHeader />
      <h2>
        Learn More
      </h2>
      <span>
        More is on the way.
      </span>
    </div>);
};

export default LearnMorePage;
